module.exports = __webpack_public_path__ + "img/D202102_4.8e31546c.jpg";